export default __webpack_public_path__ + "static/media/greentoken.6eb6f123.png";